import { ModelEntitySearchResponseItem } from '../../../../../common/model/search/types';
import { getModelEntityUrl } from '../../../../untidy/urls';
import { NavigateFunction } from 'react-router-dom';

export function handleSearchOptionChange(navigate: NavigateFunction, clickedValue?: ModelEntitySearchResponseItem) {
  if (!clickedValue) {
    return;
  }

  const { type, id, name } = clickedValue;

  const url = getModelEntityUrl(type, id, name);
  navigate(url);
}
